import { graphql } from 'gatsby'

import ProjectPage from 'views/project/ProjectPage'

export const query = graphql`
  query ProjectPageQuery($uid: String!) {
    prismic {
      page: project_page(uid: $uid, lang: "en-us") {
        page_meta_title
        page_meta_description
        page_meta_thumbnail
        title
        tagline
        subtitle
        embed_id
        square_video_webm {
          ... on PRISMIC__FileLink {
            url
          }
        }
        square_video_mp4 {
          ... on PRISMIC__FileLink {
            url
          }
        }
        square_image
        square_imageSharp {
          childImageSharp {
            fluid(maxWidth: 700) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        related_projects {
          project {
            ...PrismicLinkFrag
            ... on PRISMIC_Project_page {
              title
              portrait_video_webm {
                ... on PRISMIC__FileLink {
                  url
                }
              }
              portrait_video_mp4 {
                ... on PRISMIC__FileLink {
                  url
                }
              }
              portrait_image
              portrait_imageSharp {
                childImageSharp {
                  fluid(maxWidth: 600) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
              landscape_image
              landscape_imageSharp {
                childImageSharp {
                  fluid(maxWidth: 1000) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
        body {
          ... on PRISMIC_Project_pageBodyImages_and_text {
            type
            label
            primary {
              main_image
              main_imageSharp {
                childImageSharp {
                  fluid(maxWidth: 2000) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
              aux_image
              aux_imageSharp {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
              heading
              content
            }
          }
          ... on PRISMIC_Project_pageBodyHero_quote {
            type
            label
            primary {
              quote
            }
          }
          ... on PRISMIC_Project_pageBodyQuote {
            type
            label
            primary {
              author
              quote
            }
          }
          ... on PRISMIC_Project_pageBodyList {
            type
            label
            fields {
              item
            }
          }
          ... on PRISMIC_Project_pageBodyCredits {
            type
            label
            primary {
              section_title
            }
            fields {
              name
              role
            }
          }
          ... on PRISMIC_Project_pageBodyCards_with_title {
            type
            label
            primary {
              section_title
            }
            fields {
              card
            }
          }
          ... on PRISMIC_Project_pageBodyAwards {
            type
            label
            fields {
              award
            }
          }
        }
      }
    }
  }
`

ProjectPage.query = query
// ProjectPage.fragments = [ProjectFrag, ProjectCardFrag]

export default ProjectPage
